export default __webpack_public_path__ + "static/media/mi-photo.3df9d34a.jpeg";